<template lang="pug">
    header
      v-layout.primary.header(row wrap)
        v-flex(xs12 hidden-md-and-up)
            v-layout(row wrap)
              v-flex.shop.white.pl-2.hidden-md-and-up(sm12)
                v-layout.justify-center.py-1(row wrap)
                  v-flex.text(xs3)
                    img(src='/static/images/shop_pic.svg')
                    p ご購入は
                      br
                      | こちらから！
                  v-flex(xs4 v-for='(item, index) in shop' :key='item.key' target='_blank')
                    a(:href='item.link')
                      img.mt-1(:src='item.src')
        v-flex.px-4(xs12 md6)
          v-layout(row wrap)
            router-link(to='/top' v-scroll-to="'#top'")
              img.logo(src='/static/logo_buerger.svg' alt='ビュルガーロゴ トップページへ' width=140)
            router-link.text_nav.hidden-sm-and-down.secondary--text.mx-2(
              v-for="(item, index) in textNav"
              :to='item.key'
              :key='item.key'
              ) {{item.title}}
            a.sns(
              v-for='(item, index) in sns'
              :key='item.key'
              :href='item.link'
              target='_blank'
              )
              img(:src='item.src' alt='item.key')
            v-flex.hidden-md-and-up
              v-menu(transition='slide-y-transition' style='float:right;margin-left: -1rem')
                v-toolbar-side-icon.secondary--text.text-xs-left(slot='activator' style='froat:left')
                div.navigation-drawer(style='width:300px;')
                  v-list(two-line)
                    v-list-tile(
                      v-for='(item, index) in textNav'
                      :key='item.key'
                      :to='item.key'
                      width="100%"
                      @click.stop='drawer = !drawer'
                      )
                      v-list-tile-title {{item.title}}
        v-spacer
        v-flex.hidden-sm-and-down(md6)
          v-layout.shop.justify-center.pa-2(row wrap)
            v-flex.text(xs4)
              img(src='/static/images/shop_pic.svg')
              p.ml-1 ご購入は
                br
                | こちらから！
            v-flex(xs4 v-for='(item, index) in shop' :key='item.key' target='_blank')
              a(:href='item.link')
                img(:src='item.src')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CommonHeader',
  data: () => ({
    textNav: [{
      key: '/top',
      title: 'TOP'
    }, {
      key: '/recipe',
      title: 'おすすめレシピ'
    }, {
      key: '/company',
      title: 'ビュルガー社とは'
    }, {
      key: '/contact',
      title: 'お問い合わせ'
    }],
    sns: [{
      key: 'facebook',
      link: 'https://www.facebook.com/OtaniTrading.Foods/',
      src: require('@/../static/images/sns_facebook.png')
    }, {
      key: 'twitter',
      link: 'https://twitter.com/otani_foods?ref_src=twsrc%5Etfw',
      src: require('@/../static/images/sns_twitter.png')
    }],
    shop: [{
      title: '楽天',
      key: 'rakuten',
      link: 'https://www.rakuten.co.jp/otani-trading-foods/',
      src: require('@/../static/images/badge_shop_rakuten.png')
    }, {
      title: 'amazon',
      key: 'amazon',
      link: 'http://www.amazon.co.jp/dp/B08JCC2Y5F?ref=myi_title_dp',
      src: require('@/../static/images/badge_shop_amazon.png')
    }]
  }),
  created () {
    let self = this
    self.reloadCart()
  },
  computed: {
    ...mapGetters('app/shop', ['cartNum'])
  },
  methods: {
    ...mapActions('app/shop', ['reloadCart'])
  }
}
</script>

<style scoped lang="stylus">

// color
$color-primary = #3e2723
$color-secondary = #ecddbc
$color-red = #d0121b
// font
@import url('https://fonts.googleapis.com/css?family=Satisfy&display=swap');

// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'md-up'
            @media only screen and (min-width: screen-sm + 1)
                {block}
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs + 1)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}
header
  .header
    position fixed
    height 90px
    overflow hidden
    top 0
    z-index 2
    width 100%
    +breakpoint(sm)
      height 120px
    a
      text-decoration none
      font-size .8rem
    .logo
      margin-top 20px
      +breakpoint(sm)
        margin-top 10px
    .text_nav
      float left
      margin-top 60px
    .sns
      img
        width 30px
        float left
        margin 55px 5px 0
        +breakpoint(sm)
          float right
          margin 9px 5px 0
    .shop
      display flex
      justify-content center
      align-items center
      width 430px
      height 100px
      background-color lighten($color-secondary, 80%)
      float right
      +breakpoint(sm)
        height 80px
      .text
        margin-top -.6rem
        img
          height 20px
        p
          font-size .9rem
          line-height 1.2
          font-weight 700
          text-align center
        +breakpoint(sm)
          margin-top 0
          p
            margin-top .2rem
          img
            height 15px
            margin 0 auto
      img
        width 100px
        margin 0 auto
        &:hover
          opacity .9
      a
        width 100%
        span
          font-size .7rem
          display block
          width 100%
          font-weight 700
</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Header.vue